import { render, staticRenderFns } from "./ConfigWebsiteMarkets.vue?vue&type=template&id=087cbf93"
import script from "./ConfigWebsiteMarkets.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteMarkets.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteMarkets.vue?vue&type=style&index=0&id=087cbf93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports